import React from 'react';
import {
  Button as ShadcnButton,
  ButtonProps as ShadcnButtonProps
} from '../ui/button';
import { cn } from '../../lib/utils';

export interface LinkButtonProps extends Omit<ShadcnButtonProps, 'asChild'> {
  className?: string;
  href: string;
  target?: string;
  rel?: string;
  icon?: React.ReactNode;
}

export default function LinkButton({
  className,
  href,
  target,
  rel,
  icon,
  children,
  ...props
}: Readonly<LinkButtonProps>) {
  const content = (
    <>
      {icon && <div className='mr-2.5'>{icon}</div>}
      {children}
    </>
  );

  return (
    <ShadcnButton asChild className={cn(className)} {...props}>
      <a href={href} target={target} rel={rel}>
        {content}
      </a>
    </ShadcnButton>
  );
}
